/**
 * Sleep for a given amount of time
 * @param ms - The time to sleep in milliseconds
 * @returns {Promise<unknown>}
 */
export default async function sleep(ms) {
  return new Promise((resolve) => { setTimeout(resolve, ms); });
}
